/**
 * This middleware adds a special announcement notification to the notifications store.
 * notificationMessageTemplate is intended to change as new announcements are made.
 * If the announcement is intended to apply to all pages, rename this file to `specialAnnouncement.global.js`.
 */
import { useNotificationsStore } from '@/stores/useNotifications';
import dayjs from 'dayjs';

export default defineNuxtRouteMiddleware(async () => {
  // Check if now is after 2025-06-26 and before 2025-07-05
  const now = dayjs();
  const showAnnouncement =
    now.isAfter(dayjs('2025-06-26'), 'day') && now.isBefore(dayjs('2025-07-05'), 'day');

  if (!showAnnouncement) {
    return;
  }

  const notificationsStore = useNotificationsStore();

  const notificationParams = {
    notificationMessageTemplate: `<span class="tw-font-bold">Our support center will be closed on July 4th & will have normal Saturday hours on July 5th (9AM to 5PM EST).</span>
      Many dealers will have limited hours on these days so call dealers ahead to confirm availability.
      Reach out to <a class="tw-text-text-link-on-light tw-no-underline" href="mailto:transport@acvauctions.com">transport@acvauctions.com</a> with any questions.`,
    key: 'specialAnnouncement',
  };
  notificationsStore.addNotification(notificationParams);
  notificationsStore.setActiveNotification('specialAnnouncement');
});
